import colors from "../../config/colors";
import { ConfigComps } from "../../config/ConfigCOMP";
import { Button, Card, Grid, IconButton, TextField, Theme, useTheme } from "@mui/material";
import { TextWithLink } from "../../components/text_with_link_text/TextWithLink";
import EditText from "../../components/editText/EditText";
import { styled as styledMUI } from "@mui/material/styles";
import { useLocation, useNavigate, useParams, useRoutes } from "react-router-dom";
import links from "../../config/links";
import { useEffect, useState } from "react";
import { isVisibilityProgressBar } from "../../store/ProgressbarInRootSlice";
import { RequestHandler } from "../../api/API";
import { EnumServerSelected, HandlerLangUrl, urlsGoLang, urlsListAzmoon, urlsListPdfGenHomzhans } from "../../api/UrlsList";
import { enumTypeOfAlert } from "../../components/MUIConfig/alert_popup/interfaceAlertPopup";
import { ShowAlert } from "../../store/AlertStateModeSlice";
import { useDispatch } from "react-redux";
import { SetTokenAndRefreshToken } from "../../store/profileStateSlice";
import { GridFromMUI } from "../../components/MUIConfig/GridFromMUI";
import { DownloadDoneRounded, FileDownloadRounded, HomeRounded, PictureAsPdfRounded } from "@mui/icons-material";
import { blob } from "stream/consumers";
import TitleOfTableInResult from "../../units/tests";
import { InterfaceResponseKindTests, InterfaceShowAllKindOfTest, InterfaceTest } from "./interfaceShowAllKindOfTest";


const DivAllTextContainer = styledMUI(Card)(({ theme }) => ({
    display: "flex",
    color: "black",
    paddingTop: "calc(48px + 2vh)",
    background: "rgba(254,254,254,0.6)",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "start",
    zIndex: 100,
    maxHeight: "100%",

    // position: "absolute",
    // top: "2%",
    minWidth: "90vw",
    padding: "24px",

}));
const CardTestContainer = styledMUI(Card)(({ theme }) => ({
    display: "flex",
    width: "100%",
    color: "black",
    background: "rgba(254,254,254,0.9)",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "start",

}));

const CardTitleContainer = styledMUI(Card)(({ theme }) => ({
    display: "flex",
    width: "100%",
    color: "black",
    background: "rgba(254,254,254,0.9)",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "start",
    border: "1px solid",

}));
const ImageBackGround = styledMUI("img")(({ theme }) => ({
    objectFit: "cover",
    position: "absolute",
    top: 0,
    right: theme.direction == "rtl" ? 0 : undefined,
    left: theme.direction == "rtl" ? undefined : 0,
    zIndex: 0,
    maxHeight: "100vh",
    minWidth: "50%",

    alignItems: "center",
    width: "100%",
    height: "100%",

}));

const PTextTitle1 = styledMUI("h6")(({ theme }) => ({
    color: colors.editText.darkTitleColor,
    whiteSpace: "nowrap",


}));
const PTextTitleInCell = styledMUI("h6")(({ theme }) => ({
    color: colors.editText.darkTitleColor,
    margin: "1vh 1vw",
    [theme.breakpoints.down("md")]: {
        fontSize: "1rem"
    },
    [theme.breakpoints.down("sm")]: {
        fontSize: "0.8rem"
    }

}));
const PTextValue1 = styledMUI("p")(({ theme }) => ({
    color: colors.editText.darkTitleColor,
    whiteSpace: "pre-line",
}));
const DivGroup1 = styledMUI("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    gap: "calc(1vw + 8px)",


}));

const DivCell = styledMUI("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "start",
    gap: "calc(1vw + 8px)",
    // border: "1px solid",
    height: "100%",
    // paddingLeft: "calc(24px + 1vw)",
    // paddingRight: "calc(24px + 1vw)"


}));

const DivCellFeild = styledMUI("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "calc(1vw + 8px)",
    border: "1px solid",
    height: "100%",
    paddingLeft: "calc(24px + 1vw)",
    paddingRight: "calc(24px + 1vw)"


}));

function ShowAllKindOfTest(params: InterfaceShowAllKindOfTest) {
    const [getIsShowDownloadAllTestInDialog, setIsShowDownloadAllTestInDialog] = useState<boolean>(true);
    const [getResponseAllKindOfTest, setResponseAllKindOfTest] = useState<InterfaceResponseKindTests>();
    const [getEditTextSearch, setEditTextSearch] = useState<string>("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // let response = useLocation().state;
    window.history.replaceState({}, document.title)
    const mTheme = useTheme();
    var confComps = ConfigComps();
    const { lab_name } = useParams();


    const getAllKindTest = async () => {

        // var lab_name  ="ss"
        dispatch(isVisibilityProgressBar(true));
        await RequestHandler(dispatch, HandlerLangUrl(urlsGoLang.getAllKindOfTest.url + `${lab_name}`, mTheme, EnumServerSelected.goLangHomzhans),
            urlsGoLang.getAllKindOfTest.method, urlsGoLang.getAllKindOfTest.isTokenNecessary, undefined)
            .then((response: any) => {
                dispatch(isVisibilityProgressBar(false));
                setResponseAllKindOfTest(response)
            })
            .catch((e: Error) => {
                console.log("response:(");
                console.log(e);
                dispatch(isVisibilityProgressBar(false));
                dispatch(ShowAlert({ text: confComps.screen.answerTest.login.notification.internetFailed, typeAlert: enumTypeOfAlert.error, lastTimeSecondsUpdate: (new Date()).getSeconds() }));
            });
    }
    const removeSpecialCharacters = (strIn: string) => {
        strIn = strIn.replaceAll("\r\n", "-")
        strIn = strIn.replaceAll("--", "-")
        strIn = strIn.replaceAll("\r", " ")
        strIn = strIn.replaceAll("\n", " ")
        strIn = strIn.replaceAll("  ", " ")
        return strIn
    }
    const preparingStringForSearch = (strIn: string) => {
        strIn = strIn.replaceAll("\r\n", "")
        strIn = strIn.replaceAll("-", "")
        strIn = strIn.replaceAll("\r", "")
        strIn = strIn.replaceAll("\n", "")
        strIn = strIn.replaceAll(" ", "")
        strIn =  strIn.toLowerCase()
        return strIn
    }
    const convertTestObjToString =(test : InterfaceTest)=>{
        return(preparingStringForSearch(test.section+test.name+test.method))
    }

    useEffect(() => {
        getAllKindTest();
    }, []);
    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "start",
            justifyContent: "center",
            maxHeight: "calc(100vh - 4em)",
            overflow: "scroll",
            backgroundImage: "green",
            backgroundRepeat: "no-repeat",
            position: "relative",
            background: `url(/assets/img/background.jpg)`,
        }}>

            <DivAllTextContainer>
                <div style={{ margin: "10px calc(24px + 8vw)", width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "start" }}>
                    <EditText
                        title={confComps.screen.showAllKindTest.editTextSearch.text}
                        isNecessary={confComps.screen.showAllKindTest.editTextSearch.isNecessary}
                        hintText={confComps.screen.showAllKindTest.editTextSearch.hintText}
                        isMultiLine={confComps.screen.showAllKindTest.editTextSearch.isMultiLine}
                        isSmallTitle={false} onChangeValue={setEditTextSearch}
                        isColorDark={true}
                        isSmallHintShow={false}
                    />
                </div>


                <div style={{ margin: "10px calc(24px + 8vw)", overflowX: "scroll", maxWidth: "99vw" }}>
                    <div style={{ minWidth: "380px" }}>

                        <GridFromMUI container
                            justifyContent="left" alignItems="stretch"
                            style={{ direction: "ltr" }}
                            // columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 5, xl: 6 }}
                            rowSpacing={{ xs: 4, sm: 5, md: 5, lg: 5, xl: 5 }}
                            columns={{ xs: 1 }}
                        >
                            {getResponseAllKindOfTest?.data
                                .filter(test => convertTestObjToString(test).indexOf(preparingStringForSearch(getEditTextSearch)) >= 0 )
                                .map((test, index, array) => {
                                    return (



                                        <Grid item xs={1} key={index + "-"}>
                                            <CardTestContainer

                                            >
                                                <div
                                                    style={{ margin: "10px" }}>

                                                    <GridFromMUI container
                                                        justifyContent="left" alignItems="stretch"
                                                        columns={{ xs: 2, sm: 2, md: 4, lg: 6, xl: 8 }}

                                                    >
                                                        <Grid item xs={1}>
                                                            <DivCell>
                                                                <PTextTitleInCell>section :</PTextTitleInCell>
                                                            </DivCell>
                                                        </Grid>
                                                        <Grid item xs={1} sm={1} md={3} lg={1} xl={7}>
                                                            <DivCell>
                                                                <PTextValue1>{test.section}</PTextValue1>
                                                            </DivCell>
                                                        </Grid>

                                                        <Grid item xs={1}>
                                                            <DivCell>
                                                                <PTextTitleInCell > Test: </PTextTitleInCell>
                                                            </DivCell>
                                                        </Grid>
                                                        <Grid item xs={1} sm={1} md={3} lg={1} xl={7}>
                                                            <DivCell>
                                                                <PTextValue1>{test.name}</PTextValue1>
                                                            </DivCell>
                                                        </Grid>

                                                        <Grid item xs={1} key={4}>
                                                            <DivCell>
                                                                <PTextTitleInCell > Method</PTextTitleInCell>
                                                            </DivCell>
                                                        </Grid>
                                                        <Grid item xs={1} sm={1} md={3} lg={1} xl={7} key={5}>
                                                            <DivCell>
                                                                <PTextValue1>{test.method}</PTextValue1>
                                                            </DivCell>
                                                        </Grid>
                                                        {test.sample_type.length > 2 ?
                                                            [
                                                                <Grid item xs={1} key={"aa"}>
                                                                    <DivCell>
                                                                        <PTextTitleInCell >Sample Type</PTextTitleInCell>
                                                                    </DivCell>
                                                                </Grid>,
                                                                <Grid item xs={1} sm={1} md={3} lg={5} xl={7} key={"bb"}>
                                                                    <DivCell>
                                                                        <PTextValue1>{test.sample_type}</PTextValue1>
                                                                    </DivCell>
                                                                </Grid>
                                                            ]
                                                            : undefined
                                                        }
                                                        <Grid item xs={1} sm={1} md={2} lg={3} xl={4} key={index + "a"}>
                                                            <DivCellFeild>
                                                                <PTextTitleInCell >Field</PTextTitleInCell>
                                                            </DivCellFeild>
                                                        </Grid>
                                                        <Grid item xs={1} sm={1} md={2} lg={3} xl={4} key={index + "b"}>
                                                            <DivCellFeild>
                                                                <PTextTitleInCell>Unit</PTextTitleInCell>
                                                            </DivCellFeild>
                                                        </Grid>

                                                        {test.test_fields.flatMap((testField, index, array) => {
                                                            return [
                                                                <Grid item xs={1} sm={1} md={2} lg={3} xl={4} key={index + "a"}>
                                                                    <DivCellFeild>
                                                                        <PTextValue1 > {removeSpecialCharacters(testField.field_name)}</PTextValue1>
                                                                    </DivCellFeild>
                                                                </Grid>,
                                                                <Grid item xs={1} sm={1} md={2} lg={3} xl={4} key={index + "b"}>
                                                                    <DivCellFeild>
                                                                        <PTextValue1>{removeSpecialCharacters(testField.unit)}</PTextValue1>
                                                                    </DivCellFeild>
                                                                </Grid>,
                                                                // <Grid item xs={5} key={index + "c"}>
                                                                //     <DivCellFeild>
                                                                //         <PTextValue1>{removeSpecialCharacters(testField.normal_range)}</PTextValue1>
                                                                //     </DivCellFeild>
                                                                // </Grid>
                                                            ]
                                                        })

                                                        }
                                                    </GridFromMUI>
                                                </div>
                                            </CardTestContainer>

                                        </Grid>


                                    )
                                })}
                        </GridFromMUI>



                    </div>
                </div>

            </DivAllTextContainer >
        </div >
    )

}

export default ShowAllKindOfTest;
